<template>
  <div>
    <template v-if="view_transfer_in === true ">
      <div class="page-top mb-1 mb-3 clearfix">
        <h1 class="float-left">Transfer IN Details</h1>
      </div>

      <div class="page-top mb-1 mb-3 clearfix">
        <template v-if="batchHistory.length && hideIfStatusExist('REJECTED') && hideIfStatusExist('DISAPPROVED') && hideIfStatusExist('ARCHIVED') && hideIfStatusExist('APPROVED')">
          <template v-if="transfer_in_approver">
            <button class="btn btn-primary float-right mr-1" v-if="hideIfStatusExist('APPROVED')" data-toggle="modal" data-target="#processPopup"> Process </button>
            <button class="btn btn-primary float-right mr-1" v-if="hideIfStatusExist('APPROVED')" data-toggle="modal" data-target="#rejectPopup"> Reject </button>
          </template>
          <template v-if="transfer_in_checker">
            <a href="#" v-if="hideIfStatusExist('CHECKED')" class="btn btn-primary float-right mr-1" data-toggle="modal" data-target="#sendToApproverPopup"> Send To <template v-if="this.$global.nextChecker == ''">Approver</template><template v-else>{{this.$global.nextChecker}}</template> </a>
            <a href="#" v-if="hideIfStatusExist('CHECKED')" class="btn btn-primary float-right mr-1" data-toggle="modal" data-target="#disApproverPopup"> Disapprove </a>
          </template>
          <template v-if="transfer_in_maker">
            <a href="#" v-if="hideIfStatusExist('UNDERREVIEW')" class="btn btn-primary float-right mr-1" data-toggle="modal" data-target="#sendToCheckerPopup"> Send To <template v-if="this.$global.nextMaker == ''">Checker</template><template v-else>{{this.$global.nextMaker}}</template> </a>
            <a href="#" v-if="hideIfStatusExist('UNDERREVIEW')" class="btn btn-primary float-right mr-1" data-toggle="modal" data-target="#archivePopup"> Delete Transfer </a>
          </template>
        </template>
        <router-link to="/financeTransferInBulk" class="btn btn-primary float-right mr-1">Back</router-link>
      </div>

      <div class="batch-history mb-3 clearfix" v-if="batchHistory.length">
        <h2> <span class="text"> Batch History </span> </h2>
        <ul class="batch-status-list">
          <li class="status-list-item" v-for="bh in batchHistory" :key="bh.id">
            <span class="status uploaded" v-if="bh.action === 'UPLOAD'"> Uploaded </span>
            <span class="status flagged" v-if="bh.action === 'FLAGGED'"> Flagged
              <!-- Show Flagged Comment -->
              <div class="dropdown-menu reupload-dropdown flagged-message dropdown-menu-right">
                  <div class="dropdown-content">
                      <div class="flag"> <img src="/images/flag.png'" alt="" /> </div>
                      <div class="user-section mb-3">
                          <span class="user-image">
                              <img class="user-image" :src="'/avatar/'+bh.image" @error="$event.target.src = '/images/table-dummy-image.jpg'"/>
                          </span>
                          <p class="">
                              <span class="user-status user-name">{{bh.user.username}}</span>
                              <span class="user-status date">{{bh.updated_at | date_format_day_first}}</span>
                          </p>
                      </div>
                      <div class="text">
                          <p> {{bh.comment}} </p>
                      </div>
                  </div>
              </div>
            </span>
            <span class="status checked" v-if="bh.action == 'CHECKED'"> Checked </span>
            <span class="status uploaded" v-if="bh.action == 'REUPLOAD'"> Re-uploaded
              <!-- Show Reuploaded Comment -->
              <div class="dropdown-menu reupload-dropdown flagged-message dropdown-menu-right">
                  <div class="dropdown-content">
                      <div class="flag"> <img src="'/images/flag.png'" alt="" /> </div>
                      <div class="user-section mb-3">
                          <span class="user-image">
                              <img class="user-image" :src="'/avatar/'+bh.image" @error="$event.target.src = '/images/table-dummy-image.jpg'"/>
                          </span>
                          <p class="">
                              <span class="user-status user-name">{{bh.user.username}}</span>
                              <span class="user-status date">{{bh.updated_at | date_format_day_first}}</span>
                          </p>
                      </div>
                      <div class="text">
                          <p> {{bh.comment}} </p>
                      </div>
                  </div>
              </div>
            </span>
            <span class="status flagged" v-if="bh.action === 'UNDERREVIEW'"> Under Review </span>
            <span class="status completed" v-if="bh.action === 'APPROVED'"> Approved </span>
            <span class="status rejected" v-if="bh.action === 'DISAPPROVED'"> Disapproved
              <!-- Show Disapprove Comment -->
              <div class="dropdown-menu reupload-dropdown flagged-message dropdown-menu-right">
                  <div class="dropdown-content">
                      <div class="flag"> <img src="'/images/flag.png'" alt="" /> </div>
                      <div class="user-section mb-3">
                          <span class="user-image">
                              <img class="user-image" :src="'/avatar/'+bh.image" @error="$event.target.src = '/images/table-dummy-image.jpg'"/>
                          </span>
                          <p class="">
                              <span class="user-status user-name">{{bh.user.username}}</span>
                              <span class="user-status date">{{bh.updated_at | date_format_day_first}}</span>
                          </p>
                      </div>
                      <div class="text">
                          <p> {{bh.comment}} </p>
                      </div>
                  </div>
              </div>
            </span>
            <span class="status rejected" v-if="bh.action === 'REJECTED'"> Rejected
              <!-- Show Disapprove Comment -->
              <div class="dropdown-menu reupload-dropdown flagged-message dropdown-menu-right">
                  <div class="dropdown-content">
                      <div class="flag"> <img src="'/images/flag.png'" alt="" /> </div>
                      <div class="user-section mb-3">
                          <span class="user-image">
                              <img class="user-image" :src="'/avatar/'+bh.image" @error="$event.target.src = '/images/table-dummy-image.jpg'"/>
                          </span>
                          <p class="">
                              <span class="user-status user-name">{{bh.user.username}}</span>
                              <span class="user-status date">{{bh.updated_at | date_format_day_first}}</span>
                          </p>
                      </div>
                      <div class="text">
                          <p> {{bh.comment}} </p>
                      </div>
                  </div>
              </div>
            </span>
            <span class="status archived" v-if="bh.action === 'ARCHIVED'"> Archived </span>
          </li>
        </ul>
      </div>

      <div class="batch-process-history mb-3">
        <div class="batch-process-outer" v-for="bh in batchHistory" :key="bh.id" v-if="['UPLOAD','CHECKED','APPROVED','REUPLOAD','FLAGGED','DISAPPROVED','ARCHIVED','REJECTED'].includes(bh.action)">
          <div class="batch-process-inner created-by"  v-if="bh.action === 'UPLOAD'">
            <span class="action-by"> Created By </span>
            <div class="process-content">
              <div class="user">
                <img :src="'/avatar/'+bh.image" @error="$event.target.src = '/images/table-dummy-image.jpg'"/>
              </div>
              <p class="batch-process-text">
                <strong class="title" :title="bh.user.username"> {{ bh.user.username }} </strong>
                {{bh.user.designation ? bh.user.designation.name : 'N/A'}}
              </p>
            </div>
            <div class="created-date text-right"> {{ bh.created_at | date_format }} </div>
          </div>

          <div class="batch-process-inner checked-by" v-if="bh.action === 'CHECKED'">
            <span class="action-by"> Checked By </span>
            <div class="process-content">
              <div class="user">
                <img :src="'/avatar/'+bh.image" @error="$event.target.src = '/images/table-dummy-image.jpg'"/>
              </div>
              <p class="batch-process-text">
                <strong class="title" :title="bh.user.username"> {{ bh.user.username }} </strong>
                {{bh.user.designation ? bh.user.designation.name : 'N/A'}}
              </p>
            </div>
            <div class="created-date text-right"> {{ bh.created_at | date_format }} </div>
          </div>

          <div class="batch-process-inner approved-by" v-if="bh.action === 'APPROVED'">
            <span class="action-by"> Approved By </span>
            <div class="process-content">
              <div class="user">
                <img :src="'/avatar/'+bh.image" @error="$event.target.src = '/images/table-dummy-image.jpg'"/>
              </div>
              <p class="batch-process-text">
                <strong class="title" :title="bh.user.username"> {{ bh.user.username }} </strong>
                {{bh.user.designation ? bh.user.designation.name : 'N/A'}}
              </p>
            </div>
            <div class="created-date text-right"> {{ bh.created_at | date_format }} </div>
          </div>

          <div class="batch-process-inner reuploaded-by" v-if="bh.action === 'REUPLOAD'">
            <span class="action-by"> Reuploaded By </span>
            <div class="process-content">
              <div class="user">
                <img :src="'/avatar/'+bh.image" @error="$event.target.src = '/images/table-dummy-image.jpg'"/>
              </div>
              <p class="batch-process-text">
                <strong class="title" :title="bh.user.username"> {{ bh.user.username }} </strong>
                {{bh.user.designation ? bh.user.designation.name : 'N/A'}}
              </p>
            </div>
            <div class="created-date text-right"> {{ bh.created_at | date_format }} </div>
          </div>

          <div class="batch-process-inner flagged-by" v-if="bh.action === 'FLAGGED'">
            <span class="action-by"> Revised By </span>
            <div class="process-content">
              <div class="user">
                <img :src="'/avatar/'+bh.image" @error="$event.target.src = '/images/table-dummy-image.jpg'"/>
              </div>
              <p class="batch-process-text">
                <strong class="title" :title="bh.user.username"> {{ bh.user.username }} </strong>
                {{bh.user.designation ? bh.user.designation.name : 'N/A'}}
              </p>
            </div>
            <div class="created-date text-right"> {{ bh.created_at | date_format }} </div>
          </div>

          <div class="batch-process-inner disapprove-by" v-if="bh.action === 'DISAPPROVED'">
            <span class="action-by"> Disapproved By </span>
            <div class="process-content">
              <div class="user">
                <img :src="'/avatar/'+bh.image" @error="$event.target.src = '/images/table-dummy-image.jpg'"/>
              </div>
              <p class="batch-process-text">
                <strong class="title" :title="bh.user.username"> {{ bh.user.username }} </strong>
                {{bh.user.designation ? bh.user.designation.name : 'N/A'}}
              </p>
            </div>
            <div class="created-date text-right"> {{ bh.created_at | date_format }} </div>
          </div>

          <div class="batch-process-inner disapprove-by" v-if="bh.action === 'REJECTED'">
            <span class="action-by"> Rejected By </span>
            <div class="process-content">
              <div class="user">
                <img :src="'/avatar/'+bh.image" @error="$event.target.src = '/images/table-dummy-image.jpg'"/>
              </div>
              <p class="batch-process-text">
                <strong class="title" :title="bh.user.username"> {{ bh.user.username }} </strong>
                {{bh.user.designation ? bh.user.designation.name : 'N/A'}}
              </p>
            </div>
            <div class="created-date text-right"> {{ bh.created_at | date_format }} </div>
          </div>

          <div class="batch-process-inner archived-by" v-if="bh.action === 'ARCHIVED'">
            <span class="action-by"> Archived By </span>
            <div class="process-content">
              <div class="user">
                <img :src="'/avatar/'+bh.image" @error="$event.target.src = '/images/table-dummy-image.jpg'"/>
              </div>
              <p class="batch-process-text">
                <strong class="title" :title="bh.user.username"> {{ bh.user.username }} </strong>
                {{bh.user.designation ? bh.user.designation.name : 'N/A'}}
              </p>
            </div>
            <div class="created-date text-right"> {{ bh.created_at | date_format }} </div>
          </div>

        </div>
      </div>

      <div class="modal fade" id="sendToCheckerPopup" tabindex="-1" role="dialog" aria-labelledby="sendToCheckerLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content">
            <div class="modal-body send-to-checker-popup text-center p-4">
                    <span class="exclamation-outer">
                        <i class="fas fa-exclamation"></i>
                    </span>
              <h2 class="mt-4 mb-3"> Wait! Are you sure everything is correct? </h2>
              <button type="button" class="btn btn-primary sendtochecker" @click="updateStatus('UNDERREVIEW', 'sendToCheckerPopup')">Yes</button>
              <button type="button" class="btn btn-primary" data-dismiss="modal" aria-label="Close">No</button>
            </div>
          </div>
        </div>
      </div>

      <div class="modal fade" id="sendToApproverPopup" tabindex="-1" role="dialog" aria-labelledby="sendToCheckerLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content">
            <div class="modal-body send-to-checker-popup text-center p-4">
                <span class="exclamation-outer">
                    <i class="fas fa-exclamation"></i>
                </span>
              <h2 class="mt-4 mb-3"> Wait! Are you sure everything is correct? </h2>
              <button type="button" class="btn btn-primary sendtoapprover" @click="updateStatus('CHECKED', 'sendToApproverPopup')">Yes</button>
              <button type="button" class="btn btn-primary" data-dismiss="modal" aria-label="Close">No</button>
            </div>
          </div>
        </div>
      </div>

      <div class="modal fade" id="processPopup" tabindex="-1" role="dialog" aria-labelledby="sendToCheckerLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content">
            <div class="modal-body send-to-checker-popup text-center p-4">
                <span class="exclamation-outer">
                    <i class="fas fa-exclamation"></i>
                </span>
              <h2 class="mt-4 mb-3"> Wait! Are you sure to process? </h2>
              <button type="button" class="btn btn-primary process" @click="updateStatus('APPROVED', 'processPopup')">Yes</button>
              <button type="button" class="btn btn-primary" data-dismiss="modal" aria-label="Close">No</button>
            </div>
          </div>
        </div>
      </div>

      <div class="modal fade" id="rejectPopup" tabindex="-1" role="dialog" aria-labelledby="sendToCheckerLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content">
            <div class="modal-body send-to-checker-popup text-center p-4">
              <div class="form-group mb-3">
                <textarea v-model="reject_comment" placeholder="Why are you revising this transfer?" class="form-control"></textarea>
              </div>
              <h2 class="mt-4 mb-3"> Wait! Are you sure to reject? </h2>
              <button type="button" class="btn btn-primary process" @click="updateStatus('REJECTED', 'rejectPopup')">Yes</button>
              <button type="button" class="btn btn-primary" data-dismiss="modal" aria-label="Close">No</button>
            </div>
          </div>
        </div>
      </div>

      <div class="modal fade" id="disApproverPopup" tabindex="-1" role="dialog" aria-labelledby="sendToCheckerLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content">
            <div class="modal-body send-to-checker-popup text-center p-4">
              <div class="form-group mb-3">
                <textarea v-model="disapprove_comment" placeholder="Why are you disapproving this transfer?" class="form-control"></textarea>
              </div>
              <h2 class="mt-4 mb-3"> Wait! Are you sure to disapprove? </h2>
              <button type="button" class="btn btn-primary process" @click="updateStatus('DISAPPROVED', 'disApproverPopup')">Yes</button>
              <button type="button" class="btn btn-primary" data-dismiss="modal" aria-label="Close">No</button>
            </div>
          </div>
        </div>
      </div>

      <div class="modal fade" id="archivePopup" tabindex="-1" role="dialog" aria-labelledby="sendToCheckerLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content">
            <div class="modal-body send-to-checker-popup text-center p-4">
                <span class="exclamation-outer">
                    <i class="fas fa-exclamation"></i>
                </span>
              <h2 class="mt-4 mb-3"> Wait! Are you sure to move this transfer to Archive? </h2>
              <button type="button" class="btn btn-primary addToArchive" @click="updateStatus('ARCHIVED', 'archivePopup')">Yes</button>
              <button type="button" class="btn btn-primary" data-dismiss="modal" aria-label="Close">No</button>
            </div>
          </div>
        </div>
      </div>

      <table id="dt-new" class="table" style="width:100%">
        <thead>
        <tr>
          <th style="display: none;"></th>
          <th>Company Wallet</th>
          <th>Amount</th>
          <th>Narration</th>
          <th>Transaction ID</th>
          <th>Reversal Date</th>
          <th>Status</th>
        </tr>
        </thead>
      </table>

    </template>
    <template v-else-if="view_transfer_in === null">
      <preLoader></preLoader>
    </template>
    <template v-else-if="view_transfer_in === false">
      <notAllowed></notAllowed>
    </template>

  </div>
</template>

<script>
var gThat = null;
var myTable = null;
export default {
  data() {
    return {
      companies: [],
      listingData:[],
      form: new Form({
        company_id: '',
        amount : '',
        // transaction_id : '',
        transaction_ref : '',
        description : '',
        date:new Date()
      }),
      new_transaction_count : 0,
      inprocess_transaction_count : 0,
      rejected_transaction_count : 0,
      paid_transaction_count: 0,
      dtNewBPayments: null,
      dtInProcessBPayments: null,
      dtRejectedBPayments: null,
      dtPaidBPayments: null,

      view_transfer_in: null,
      crud_transfer_in:null,
      bulkTransferInID : this.$route.params.id,
      transfer_in_maker: false,
      transfer_in_checker: false,
      transfer_in_approver: false,
      reject_comment: '',
      disapprove_comment: '',
      batchHistory: [],
    }
  },
  methods: {

    newListData: function(){
      let that = this;
      gThat.dtNewBPayments = $('#dt-new').DataTable({
        processing: true,
        serverSide: true,
        searching: false,
        sDom : '<"row view-filter"<"clearfix">><"table-holder mb-3"t><"row view-pager"<"col-sm-4 text-left"i"><"col-sm-4 text-center"p"><"col-sm-4 text-right"l>>r',
        ajax: {
          //this.bulkTransferInID",
          "url": "/api/listNewBulkTransferInDetails/"+ this.$route.params.id,
          "headers": window.axios.defaults.headers.common,
          "dataSrc": "records",
          "complete": function (data,json, type) {
            gThat.listingData = data.responseJSON.records;
            that.batchHistory = data.responseJSON.history;
            if (type == "parsererror") {
              gThat.$Progress.fail();
            }else{
              gThat.$Progress.finish();
            }
          }
        },
        deferRender: true,
        columns: [
          {data: 'id', visible: false},
          {data: 'company_wallet'},
          {data: 'amount'},
          {data: 'narration'},
          {data: 'transaction_id'},
          {data: 'reversal_date'},
          {data: 'status'},
        ],
        "order": [[ 0, "desc" ]],
        "initComplete": (settings, json) => { this.new_bills_count = json.recordsTotal; }
      });
    },
    updateStatus(status, modal){
      axios.post('/api/updateTransferInBatchStatus', {
        batchId: this.$route.params.id,
        reject_comment: this.reject_comment,
        disapprove_comment: this.disapprove_comment,
        status
      })
        .then(res => {
          if (res.data.code == 200) {
            if (this.$global.nextMaker == '') {
              this.showToastBox('success', res.data.message);
            } else {
              this.showToastBox('success', 'You batch is sent to ' + this.$global.nextmaker + ' successfully');
            }
            $('#'+ modal).modal('hide');
          } else {
            this.showAlertBox('error', res.data.msg);
          }
          $('#dt-new').DataTable().destroy();
          this.newListData();
        })
        .catch(error => {
          if (error.response.status === 422) {
            let errorMessages = '';
            let errors = Object.values(error.response.data.errors);
            errors = errors.flat();

            errorMessages = 'Please provide following details:' + '\n';
            $.each(errors, (key, value) => {

              errorMessages += (key + 1) + ': ' + value + '\n';
            });
            this.showAlertBox('error', errorMessages);
          } else {
            this.showAlertBox('error', 'Error to load data');
          }
          this.$Progress.fail();
        });
    },
    hideIfStatusExist(status){
      return !this.batchHistory.find(x => x.action === status);
    }

  },
  mounted() {

    gThat = this;
    this.$Progress.start();
    this.can('transfer_in|crud_transfer_in|transfer_in_maker|transfer_in_checker|transfer_in_approver').then(result => {
      this.view_transfer_in = result.transfer_in;
      this.crud_transfer_in = result.crud_transfer_in;
      this.transfer_in_maker = result.transfer_in_maker;
      this.transfer_in_checker = result.transfer_in_checker;
      this.transfer_in_approver = result.transfer_in_approver;
    }).then(result => {
      if(this.view_transfer_in == true){
         this.newListData();
        this.$Progress.finish();
      }else{
        this.$Progress.finish();
      }
    });
  }
}
</script>
